import * as React from 'react';
import {
    UpgradeHelper, IJourneyItem, AdminToolPanelHelper
} from '../../helpers';
import { Search } from '../common/search';
import { TextField, Button, ButtonType } from 'office-ui-fabric-react';
declare var jQuery;
interface IProps {
    adminToolState: any;
    panelName: any;
    disable: boolean;
}

export class SearchFilter extends React.Component<IProps, any> {
    componentDidMount() {
    }
    setFilter = () => {
        let getValue:string = jQuery("#searchTxt").val();
        AdminToolPanelHelper.SetSearchFilters(this.props.adminToolState, this.props.panelName, getValue);
        AdminToolPanelHelper.SetPaging(this.props.adminToolState, this.props.panelName, 0);       
    }

    onChangeValue = () => {
        AdminToolPanelHelper.SetSearchFilters(this.props.adminToolState, this.props.panelName, "");
    }

    render() {
        return (<div className={"searchfilter"}>
            <TextField onKeyPress={(event) =>{
                if(event.key === 'Enter')
                {
                    this.setFilter();
                }
            }} onChanged={() =>this.onChangeValue()} disabled={this.props.disable} id="searchTxt" name="search" /> <Button disabled={this.props.disable} buttonType={ButtonType.primary} onClick={() => this.setFilter()} icon="Search" ></Button>
        </div>
        );
    }
}  



// WEBPACK FOOTER //
// ./source/ts/components/admintool/searchfilter.tsx